<template>
  <div>
    <validation-observer ref="simpleRules">
      <b-form>
        <b-row>
          <b-col
            cols="12"
          >
            <b-card
              border-variant="success"
              bg-variant="transparent"
              class="shadow-none module-card"
            >
              <b-form-group
                :label="$t('DEBTIA_OPERATOR')"
                label-for="process-operator"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('DEBTIA_OPERATOR')"
                  rules="required"
                >
                  <v-select
                    v-model="bailiffStatus"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="operatorOptions"
                    :reduce="val => val.value"
                    :clearable="false"
                    input-id="process-operator"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-button
                variant="primary"
                type="submit"
                class="addAwaitBtn"
                @click.prevent="validationAwaitForm"
              >
                {{ $t('DEBTIA_SUBMIT') }}
              </b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BForm,
  BRow,
  BCol,
// BInputGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import { required, integer } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'

export default {
  components: {
    BCard,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  props: {
    conditionObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      integer,
      operatorOptions: [
        { label: 'True', value: true },
        { label: 'False', value: false },
      ],
      bailiffStatus: true,
    }
  },
  created() {
  },
  methods: {
    validationAwaitForm() {
      const processID = this.$route.params.id
      const dataObj = {
        process_id: Number(processID),
        module_id: 18,
        module_order: 1,
        bailiff_status: this.bailiffStatus,
      }
      if (this.conditionObject.moduleID > 0) {
        dataObj.depends_on = this.conditionObject.moduleID
        dataObj.condition = this.conditionObject.type
      }
      const url = '/process/module/add'
      axios.post(url, dataObj).then(response => {
        if (response.status === 200) {
          const returnObj = {
            parentID: this.conditionObject.parentID,
            depend: dataObj.depends_on,
            bailiff_status: this.bailiffStatus,
          }
          returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
          this.$emit('closeBailiffModal', returnObj)
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.addAwaitBtn {
    width: 100%;
}
</style>
